<template lang="pug">
  div
    v-container.flex-grow-1(fluid)
      v-row.d-flex
        p {{instructions}}
      v-row.d-flex.align-center
        PhotoLoad.flex-grow-0(ref='photoLoader'
                              @image-loaded="onImageLoaded"
                              :max-width="1200"
                              :max-height="1200")
        v-progress-circular.ml-4(v-if="isLoading || isEstimating"
                                 color="primary"
                                 indeterminate)
</template>

<script>
import Vue from 'vue'
import * as poseDetection from '@tensorflow-models/pose-detection'
import '@tensorflow/tfjs-backend-webgl'
import PhotoLoad from '@/components/mediaLoad/photo-load'
import PoseExtractor from './BlazePose'
import poseEstimateResource from '@/resources/poseEstimate'

export default {
  name: 'ImagePoseProvider',
  components: { PhotoLoad },
  data: function () {
    return {
      isLoading: false,
      isEstimating: false,
      instructions: poseEstimateResource.defaultInstructions,
      detectorImgSrc: '',
      imgSrc: ''
    }
  },
  mounted () {
    const hasCaptureSupport = this.$refs.photoLoader.hasCaptureSupport()
    this.instructions = hasCaptureSupport
      ? poseEstimateResource.cameraInstructions
      : poseEstimateResource.defaultInstructions
  },
  methods: {
    async createPoseDetector () {
      const detectorConfig = {
        modelType: 'heavy',
        runtime: 'tfjs'
      }
      const mlModel = poseDetection.SupportedModels.BlazePose
      this.isLoading = true
      try {
        return poseDetection.createDetector(mlModel, detectorConfig)
      } finally {
        this.isLoading = false
      }
    },
    onImageLoaded ({ img }) {
      this.estimatePose(img)
    },
    async estimatePose (imageData) {
      if (!imageData.src) {
        Vue.logger.log('Not estimating image without src')
        return
      }

      // TODO Hash/fingerprint and avoid storing all image data
      this.imageSrc = imageData.src
      this.isEstimating = true
      this.$emit('is-estimating', true)
      let estimatedData = {}
      try {
        if (!this.poseDetector || this.detectorImgSrc !== this.imageSrc) {
          this.poseDetector = await this.createPoseDetector()
          this.detectorImgSrc = this.imageSrc
        }
        const estimation = await this.poseDetector.estimatePoses(imageData)
        const data = new PoseExtractor(estimation).data
        if (imageData.src === this.imageSrc) {
          estimatedData = data
        }
      } catch (e) {
        if (e.message !== 'Invalid pose estimation') {
          estimatedData = { error: e }
          Vue.logger.error(e)
        }
      } finally {
        this.isEstimating = false
      }
      this.$emit('pose-data', { data: estimatedData })
    }
  }
}
</script>
